module.exports = __webpack_public_path__ + "static/media/0004.d6764ac.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/0004.mp3
// module id = hKZm
// module chunks = 0